import styled from 'styled-components';
import { Row, Col } from 'antd';

export const RowFilters = styled(Row)`
    display: flex;
    transition: all ease 0.4s;
    margin-top: 16px;
`;

export const ColFields = styled(Col)`
    display: flex;
    flex-wrap: wrap;
`;

export const ColButtons = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const TableActions = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;